import Common from './common';
const common = new Common();

export default class Nav {
  init() {
    this.open();
    this.active();
    this.fixed();
  }
  open() {
    var { media } = common.getEnvironment();
    if(media == 'pc') {
      $('.js_nav_local_sub').click(function() {
        const $target = $(this).next('.c_nav_local_sub_wrap');
        $('.c_nav_local_sub_wrap').not($target).hide();
        $target.toggle();
      });
      $('body').on('click', function (e) {
        if ($(e.target).closest('.c_nav_item_arrow').length === 0) {
          $('.c_nav_local_sub_wrap').hide();
        }
      });
    } else if(media == 'sp'){
			$('.js_nav_local').click(function() {
				$('.c_nav_local').slideToggle();
				$(this).toggleClass('is_open');
			});
			$('.js_nav_local_sub').click(function() {
				$(this).next('.c_nav_local_sub_wrap').slideToggle();
				$(this).closest('li').toggleClass('is_open');
				$(this).toggleClass('is_current');
			});
		}
  }
  active() {
    const splitedPath = location.pathname.split('/');
    const pageHtmlName = splitedPath[splitedPath.length - 1];
    if (pageHtmlName === '' || pageHtmlName === 'index.html') {
      $('.js_nav_local_top').addClass('is_current');
    } else if (pageHtmlName === 'supplies.html') {
      $('.js_nav_local_supplies').addClass('is_current');
    } else {
      const splitedPageHtmlName = pageHtmlName.split('-');
      const pageCategory = splitedPageHtmlName[0];
      const pageName = splitedPageHtmlName[1];

      $(`.js_nav_local_${pageCategory}`).addClass('is_current');
      $(`.js_nav_local_${pageCategory} + .c_nav_local_sub_wrap a[href$="${pageName}"]`).addClass('is_current');
    }
  }
  fixed() {
    var { media } = common.getEnvironment(),
        $header = $('.global-header'),
        $globalNav = $('.global-nav-bar'),
        $nav = $('.c_nav_local_wrap'),
        $breadcrumbs = $('.breadcrumbs'),
        navPos = $nav.offset().top,
        bodyMaginTop = navPos - $nav.outerHeight(),
        fixedClass = 'is_fixed';
    if(media == 'pc') {
      $(window).on('load scroll', function() {
        var value = $(this).scrollTop();
        if (value > navPos) {
          $header.addClass(fixedClass);
          $globalNav.addClass(fixedClass);
          $nav.addClass(fixedClass);
          $breadcrumbs.addClass(fixedClass);
          $('body').css('margin-top', bodyMaginTop);
          $header.css('top', -$header.outerHeight());
          $globalNav.css('top', -$globalNav.outerHeight());
        } else {
          $header.removeClass(fixedClass);
          $globalNav.removeClass(fixedClass);
          $nav.removeClass(fixedClass);
          $breadcrumbs.removeClass(fixedClass);
          $('body').css('margin-top', '0');
          $header.css('top', 'auto');
          $globalNav.css('top', 'auto');
        }
      });
    }
  }
}



// WEBPACK FOOTER //
// ./src/assets/js/modules/nav.js